<template>
  <div
    class="mod_header"
    :class="[
      isShowNav ? 'mod_header_m' : 'mod_header_n',
      { mod_header_news: isNewsPage },
      { mod_header_hero: isHomeFirstPart },
    ]"
  >
    <transition name="fade">
      <div v-show="isShowNav" class="mask" @click="isShowNav = false"></div>
    </transition>

    <div class="main_contain">
      <div class="header_main">
        <div class="header_left">
          <div class="logo_box">
            <img
              class="logo_img hidden-xs"
              src="../assets/img/logo_gigi_w.png"
              alt=""
            />
            <img
              class="logo_img visible-xs-block"
              src="../assets/img/logo_gigi_w.png"
              alt=""
            />
          </div>
        </div>
        <div v-if="isMoblie" class="menu_title">{{ currentNavTitle }}</div>
        <div
          class="menu_button"
          @click="isShowNav = !isShowNav"
          :class="isShowNav ? 'cross' : ''"
        >
          <div class="bar"></div>
          <div class="bar"></div>
          <div class="bar"></div>
        </div>

        <transition name="dropdown">
          <div v-show="isShowNav || !isMoblie" class="header_right">
            <div class="header_menu">
              <div
                @click="activeToPart(1)"
                class="menu_item"
                :class="!isMoblie ? 'hvr-bounce-to-bottom' : ''"
              >
                首页
              </div>
              <div
                @click="activeToPart(2)"
                class="menu_item"
                :class="!isMoblie ? 'hvr-bounce-to-bottom' : ''"
              >
                关于我们
              </div>
              <div
                @click="activeToPart(3)"
                class="menu_item"
                :class="!isMoblie ? 'hvr-bounce-to-bottom' : ''"
              >
                平台介绍
              </div>
              <div
                @click="activeToPart(4)"
                class="menu_item"
                :class="!isMoblie ? 'hvr-bounce-to-bottom' : ''"
              >
                解决方案
              </div>
              <div
                @click="activeToPart(5)"
                class="menu_item"
                :class="!isMoblie ? 'hvr-bounce-to-bottom' : ''"
              >
                信息安全
              </div>

              <div
                @click="activeToPart(6)"
                class="menu_item"
                :class="!isMoblie ? 'hvr-bounce-to-bottom' : ''"
              >
                联系我们
              </div>
              <div
                @click="activeToPart(7)"
                class="menu_item"
                :class="!isMoblie ? 'hvr-bounce-to-bottom' : ''"
              >
                招纳贤士
              </div>
              <div
                @click="activeToPart(9)"
                class="menu_item"
                :class="!isMoblie ? 'hvr-bounce-to-bottom' : ''"
              >
                新闻动态
              </div>
              <div
                @click="activeToPart(8)"
                class="menu_item"
                :class="!isMoblie ? 'hvr-bounce-to-bottom' : ''"
              >
                下载中心
              </div>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref, onUnmounted, computed, watch } from "vue";
import { emitEvent, onEvent, offEvent } from "@/utils/eventBus";
import { useRoute, useRouter } from "vue-router";
const isShowNav = ref(false);
const isMoblie = ref(true);
const navTitle = ref("首页");
const route = useRoute();
const router = useRouter();

const isNewsPage = computed(() => route.path.startsWith("/news"));
const currentNavTitle = computed(() =>
  isNewsPage.value ? "新闻动态" : navTitle.value
);

/** 与 HomeView 中 getNav 一致：0 表示首屏第一块 panel */
const homePanelIndex = ref(0);

watch(
  () => route.path,
  (path) => {
    homePanelIndex.value = path === "/" ? 0 : -1;
  },
  { immediate: true }
);

const isHomeFirstPart = computed(
  () => route.path === "/" && homePanelIndex.value === 0
);

const setRootFontSize = () => {
  const screenWidth = window.innerWidth;
  if (screenWidth <= 768) {
    isMoblie.value = true;
    isShowNav.value = false;
  } else {
    isMoblie.value = false;
    isShowNav.value = false;
  }
};

const activeToPart = (index) => {
  if (isMoblie.value) {
    isShowNav.value = false;
  }

  if (index === 9) {
    router.push("/news");
    return;
  }

  if (route.path !== "/") {
    router.push({
      path: "/",
      query: { part: String(index) },
    });
    return;
  }

  emitEvent("partIndex", index);
};

const handleNav = (nav) => {
  if (route.path === "/") {
    homePanelIndex.value = nav;
  }
  navTitle.value =
    nav == 1
      ? "关于我们"
      : nav == 2
      ? "平台介绍"
      : nav == 3
      ? "解决方案"
      : nav == 4
      ? "信息安全"
      : nav == 5
      ? "联系我们"
      : nav == 6
      ? "招纳贤士"
      : nav == 7
      ? "下载中心"
      : "首页";
};

onMounted(() => {
  setRootFontSize();
  window.addEventListener("resize", setRootFontSize);
  onEvent("getNav", handleNav);
});

onUnmounted(() => {
  window.removeEventListener("resize", setRootFontSize);
  offEvent("getNav", handleNav);
});
</script>

<style lang="scss" scoped>
.mod_header {
  height: 68px;
  width: 100%;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 99;
  display: flex;
  align-items: center;
  /* 几乎只靠模糊，遮罩极淡 */
  background: rgba(255, 255, 255, 0.03);
  backdrop-filter: blur(20px) saturate(120%);
  -webkit-backdrop-filter: blur(20px) saturate(120%);
  box-shadow: 0 1px 0 rgba(255, 255, 255, 0.04) inset;
  transition: background 0.25s ease, box-shadow 0.25s ease,
    backdrop-filter 0.25s ease, -webkit-backdrop-filter 0.25s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.08);
    backdrop-filter: blur(22px) saturate(125%);
    -webkit-backdrop-filter: blur(22px) saturate(125%);
    box-shadow: 0 1px 0 rgba(255, 255, 255, 0.06) inset,
      0px 4px 16px rgba(0, 0, 0, 0.05);
  }

  @supports not (
    (backdrop-filter: blur(1px)) or (-webkit-backdrop-filter: blur(1px))
  ) {
    background: rgba(0, 0, 0, 0.38);
    &:hover {
      background: rgba(0, 0, 0, 0.45);
    }
  }

  .main_contain {
    height: 100%;
  }
  .header_main {
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: 100%;
    .logo_box {
      display: flex;
      align-items: center;
      cursor: pointer;
      .logo_img {
        height: 32px;
      }
      .logo_title {
        color: #fff;
        font-size: 20px;
        line-height: 28px;
        margin-left: 4px;
      }
    }
    .header_menu {
      display: flex;
      align-items: center;
      height: 100%;
      .menu_item {
        height: 68px;
        line-height: 68px;
        color: rgba($color: #fff, $alpha: 1);
        font-size: 18px;
        padding: 0 20px;
        cursor: pointer;
      }
    }
  }
  .header_left {
    display: flex;
  }
  .header_right {
    display: flex;
  }

  &.mod_header_hero {
    background: transparent;
    backdrop-filter: none;
    -webkit-backdrop-filter: none;
    box-shadow: none;
    &:hover {
      background: transparent;
      backdrop-filter: none;
      -webkit-backdrop-filter: none;
      box-shadow: none;
    }
    @supports not (
      (backdrop-filter: blur(1px)) or (-webkit-backdrop-filter: blur(1px))
    ) {
      background: transparent;
      &:hover {
        background: transparent;
      }
    }
  }
}

a {
  color: #606266;
  &:hover {
    color: #303133;
  }
}

.router_link_active {
  color: #303133;
  font-weight: bold;
  position: relative;
  &::after {
    content: "";
    height: 4px;
    width: 28px;
    border-radius: 4px;
    display: block;
    background: #29a69c;
    position: absolute;
    bottom: 24px;
    left: 50%;
    margin-left: 14px;
  }
}

@media (max-width: 1200px) {
  .mod_header .header_main .header_menu .menu_item {
    font-size: 16px;
    padding: 0 12px;
  }
}

@media (max-width: 750px) {
  .mod_header {
    height: 56px;
    z-index: 99;
    .header_main {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 100%;
      padding: 0 16px;
      box-sizing: border-box;
      z-index: 99;
      position: relative;
      .header_right {
        position: absolute;
        width: 100%;
        left: 0;
        top: 56px;
        background: #29a69c;
        overflow: hidden;
        z-index: 99;

        .header_menu {
          display: flex;
          flex-direction: column;
          width: 100%;
          padding: 0 16px 16px;
          .menu_item {
            width: 100%;
            text-align: left;
            font-size: 15px;
            border-bottom: 1px solid #ffffff83;
            height: 48px;
            line-height: 48px;
          }
        }
      }
    }

    .header_left {
      .logo_img {
        height: 24px !important;
        margin-left: 0;
      }
    }
    .menu_title {
      color: #fff;
      font-size: 16px;
      font-weight: 400;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
    .menu_button {
      cursor: pointer;
      -webkit-transition: 0.3s;
      transition: 0.3s;
      background-color: transparent;
      position: relative;
      height: 20px;
      margin-right: 0;
      .bar {
        position: relative;
        display: block;
        width: 24px;
        height: 2px;
        min-height: 2px;
        margin: 6px auto;
        background-color: #fff;
        border-radius: 4px;
        -webkit-transition: 0.3s;
        transition: 0.3s;
        &:nth-of-type(1) {
          margin-top: 0;
        }
        &:nth-of-type(3) {
          margin-bottom: 0;
        }
      }
    }

    .cross {
      .bar:nth-of-type(1) {
        transform: translateY(8px) rotate(-45deg);
      }
      .bar:nth-of-type(2) {
        opacity: 0;
      }
      .bar:nth-of-type(3) {
        transform: translateY(-8px) rotate(45deg);
      }
    }
  }

  .mod_header_m {
    background: rgba(255, 255, 255, 0.03);
    backdrop-filter: blur(18px) saturate(120%);
    -webkit-backdrop-filter: blur(18px) saturate(120%);
    box-shadow: none;
  }
  .mod_header_n {
    background: rgba(255, 255, 255, 0.04);
    backdrop-filter: blur(20px) saturate(120%);
    -webkit-backdrop-filter: blur(20px) saturate(120%);
    &:hover {
      background: rgba(255, 255, 255, 0.08);
      backdrop-filter: blur(22px) saturate(125%);
      -webkit-backdrop-filter: blur(22px) saturate(125%);
      box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.06);
    }
  }

  .mod_header.mod_header_news {
    background: linear-gradient(
        180deg,
        rgba(255, 255, 255, 0.06) 0%,
        rgba(255, 255, 255, 0.02) 100%
      ),
      url("@/assets/img/news_title_bg.png") no-repeat center/cover;
    backdrop-filter: blur(16px) saturate(115%);
    -webkit-backdrop-filter: blur(16px) saturate(115%);
  }

  .mod_header.mod_header_hero.mod_header_m,
  .mod_header.mod_header_hero.mod_header_n {
    background: transparent;
    backdrop-filter: none;
    -webkit-backdrop-filter: none;
    box-shadow: none;
    &:hover {
      background: transparent;
      backdrop-filter: none;
      -webkit-backdrop-filter: none;
      box-shadow: none;
    }
  }

  /* 过渡动画 */
  .dropdown-enter-active,
  .dropdown-leave-active {
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  }

  .dropdown-enter-from,
  .dropdown-leave-to {
    opacity: 0;
    transform: translateY(-20px); /* 初始向上偏移 */
    max-height: 0; /* 初始高度为0 */
  }

  .dropdown-enter-to,
  .dropdown-leave-from {
    opacity: 1;
    transform: translateY(0); /* 最终位置 */
    max-height: 100vh; /* 足够大的高度容纳内容 */
  }

  .mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.4);
    z-index: 98; /* 低于菜单的z-index */
  }

  /* 禁用滚动条样式 */
  .no-scroll {
    overflow: hidden !important;
    touch-action: none; /* 禁用触摸滚动 */
  }

  /* 遮罩过渡动画 */
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.3s;
  }
  .fade-enter-from,
  .fade-leave-to {
    opacity: 0;
  }
}
</style>
